<template>
  <v-tooltip top :disabled="!tooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        :style="{ cursor: tooltip ? 'help' : 'default' }"
        :color="color"
        size="20px"
        v-on="on"
        v-bind="attrs"
      >
        <slot></slot>
      </v-icon>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "Icon",
  props: {
    tooltip: { type: String },
    color: { type: String, default: "primary" },
  },
})
</script>
